export var GameState;
(function (GameState) {
    GameState[GameState["ChooseUsername"] = 0] = "ChooseUsername";
    GameState[GameState["Lobby"] = 1] = "Lobby";
    GameState[GameState["SubmitGIF"] = 2] = "SubmitGIF";
    GameState[GameState["Vote"] = 4] = "Vote";
    GameState[GameState["VoteResults"] = 8] = "VoteResults";
    GameState[GameState["GameEnd"] = 65536] = "GameEnd";
})(GameState || (GameState = {}));
